import React from "react";
import { blogsList } from "../../utils/blogs-list";
import Paragraph from "../common/ui/Paragraph";
const RecentPost = () => {
  return (
    <div className="space-y-4">
      {blogsList.slice(0, 3).map((obj, index) => (
        <div key={index} className="flex gap-x-4 items-center">
          <div className="relative aspect-auto max-w-[114px] h-[79px] overflow-clip w-full rounded">
            <img
              src={obj.image}
              className="absolute top-0 left-0 h-full w-full object-cover group-hover:scale-105"
              onError={(e) => (e.currentTarget.style.display = "none")}
              alt="gallery content"
            />
          </div>
          <div className="w-full">
            <Paragraph className="!text-custom-blue-v2">{obj.date}</Paragraph>
            <Paragraph className="!font-semibold mt-[7px] !text-custom-black line-clamp-2">
              {obj.title}
            </Paragraph>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RecentPost;
